import React, { useEffect /*, useLayoutEffect */ } from 'react';
import Box from '@mui/material/Box';
import CssBaseline from '@mui/material/CssBaseline';
import { SettingsSideBar } from './components/SettingsSideBar';
import { SettingsProvider } from './context/SettingsContext';
import { SettingsContainer } from './components/SettingsContainer';
import { Routes, Route, useLocation } from 'react-router-dom';
import { usePermissions } from '../../context/PermissionsContext/PermissionsContext';
import { AccuLynxSetup } from './components/Integrations/components/AccuLynxSetup';
import { LeapSetup } from './components/Integrations/components/LeapSetup';
import { LeapHelp } from './components/Integrations/components/LeapHelp';
import { AccuLynxHelp } from './components/Integrations/components/AccuLynxHelp';
import { JobNimbusSetup } from './components/Integrations/components/JobNimbusSetup';
import { JobNimbusHelp } from './components/Integrations/components/JobNimbusHelp';
import { EagleViewSetup } from './components/Integrations/components/EagleViewSetup';
import { EagleViewCallback } from './components/Integrations/components/EagleViewCallback';
import { isStarterAccount } from '../../common/utils/isStarterAccount';

const SettingsPage = () => {
  const { isSuperAdmin } = usePermissions();

  const location = useLocation();
  useEffect(() => {
    // @ts-ignore
    const canAccessSettings = isSuperAdmin() || global?.me?.isAdmin;
    if (location.pathname.startsWith('/settings') && !canAccessSettings) {
      console.log('not authorized to access settings');
      if (window.history.length > 1) {
        window.history.back();
      } else {
        window.location.href = isStarterAccount() ? '/pipeline' : '/feed';
      }
    }
  }, [location.pathname]);

  return (
    <SettingsProvider>
      <Box
        sx={(theme) => ({
          display: 'flex',
          backgroundColor: theme.custom?.background1,
          minHeight: '100vh',
        })}
      >
        <CssBaseline />
        <SettingsSideBar />
        <Routes>
          <Route
            path="integrations/acculynx/setup"
            element={<AccuLynxSetup />}
          />
          <Route path="integrations/acculynx/help" element={<AccuLynxHelp />} />
          <Route path="integrations/leap/setup" element={<LeapSetup />} />
          <Route path="integrations/leap/help" element={<LeapHelp />} />
          <Route
            path="integrations/jobnimbus/setup"
            element={<JobNimbusSetup />}
          />
          <Route
            path="integrations/jobnimbus/help"
            element={<JobNimbusHelp />}
          />
          <Route
            path="integrations/eagleview/setup"
            element={<EagleViewSetup />}
          />
          <Route
            path="integrations/eagleview/callback"
            element={<EagleViewCallback />}
          />
          <Route path="*" element={<SettingsContainer />} />
        </Routes>
      </Box>
    </SettingsProvider>
  );
};

export { SettingsPage };
